"use strict";
exports.__esModule = true;
exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["CONTACT"] = "contact";
    EntityType["COMPANY"] = "company";
    EntityType["DEAL"] = "deal";
    EntityType["PRODUCT"] = "product";
    EntityType["ACTIVITY"] = "activity";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
